

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","style":"enable-background:new 0 0 100 100","version":"1.1","viewBox":"0 0 100 125","xml:space":"preserve"}, rest), ["\n    ", h('path', {"fill":"currentColor","d":"M13.1,51.1h71.4l-6.8,6.8c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l8.5-8.5c0.4-0.4,0.4-1,0-1.4  l-8.5-8.5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.8,6.8H13.1c-0.6,0-1,0.4-1,1S12.5,51.1,13.1,51.1z"}, []), "\n"]);
};

        